import React from "react";
import "./add password.css";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
} from "mdbreact";
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import {setUser} from '../../redux/actions/AuthActions'
import {hasValue} from '../../validations/validations'
import {message} from 'antd';

class AddPassword extends React.Component {
  state = {
    password: "",
    confirmPassword:"",
  };

  constructor(props){
    super(props)
    console.log("isr   ",this.props.history)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
    window.scrollTo(0,0)
  }
  addPassword = () =>{
    const {password,confirmPassword} = this.state
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    if(hasValue(password)&&hasValue(confirmPassword)){
      if(password===confirmPassword){
        let l = message.loading(allStrings.wait, 2.5)
        axios.post(`${BASE_END_POINT}addAdminPassword`, JSON.stringify({
          password:password,
          token:token,
        }), {
          headers: { 
            'Content-Type':  'application/json',
            'Accept-Language':this.props.isRTL?'ar':'en'
         },
        })
        .then(response=>{
            console.log("DONE P3")
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.replace('/Login') 
        })
        .catch(error=>{
            console.log("ERROR P3 ",error.response)
            l.then(() => message.error('active', 2.5))
        })
       
      }else{
        message.warning(allStrings.passwordMustEqualConfirmPassword);
      }
    }else{
      console.log("NO VALUES OF PAGE 3")
    }
  }


  submitHandler = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.addPassword()
  };
  changeHandler = (event) => {
    console.log(event.target.value);
    this.setState({ [event.target.name]: event.target.value });
  };
 
  render() {
    console.log(this.state.step)
    return (
      <div className="login">
        <MDBContainer className="loginContainer">
          <MDBRow>
            <MDBCol  xl="6" lg="6" md="4" sm="12" className="noPadding">
              <div className="loginLeft">

              </div>
            </MDBCol>
            <MDBCol  xl="6" lg="6" md="8" sm="12">
              <div className="loginRight">
                <div className="logoDiv">
                  <img alt="" style={{
                      margin: 'auto',
                      display: 'block',
                      marginTop: '4rem'
                  }} width="120px" src={require('../../assets/images/logo-1.svg')}></img>
                </div>
                <br></br>
                <div className="formContainer">
                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >
                            <div className="grey-text">
                              <MDBInput
                                name="password"
                                hint={allStrings.newPassword}
                                style={{direction:this.props.isRTL?'rtl':'ltr'}}
                                //icon="envelope"
                                group
                                type="password"
                                onChange={this.changeHandler}
                                required
                                validate
                                error="wrong"
                                success="right"
                              />
                              <div className="valid-feedback">Looks good!</div>
                              <MDBInput
                                name="confirmPassword"
                                hint={allStrings.newTime}
                                style={{direction:this.props.isRTL?'rtl':'ltr'}}
                                //icon="envelope"
                                group
                                type="password"
                                onChange={this.changeHandler}
                                required
                                validate
                                error="wrong"
                                success="right"
                              />
                              <div className="valid-feedback">Looks good!</div>
                            </div>
                            <div className="text-center">
                              <MDBBtn
                                type="submit"
                                style={{ backgroundColor: '#117183 ',width:'170px' }}
                                rounded
                                className="btn z-depth-1a"
                              >
                                {allStrings.enter}
                              </MDBBtn>
                            </div>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

const mapToStateProps = state => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  })
  
  const mapDispatchToProps = {
    setUser,
  }
  
  export default  withRouter(
    connect(mapToStateProps,mapDispatchToProps)(AddPassword)
  );
  
